/* eslint-disable no-unused-vars */
import * as Yup from 'yup'

export const schemaPickingProductValidation = Yup.object({
  sku: Yup.string()
    .min(3, 'Debe ingresar a lo menos 3 caracteres')
    .max(50, 'El campo acepta como máximo 50 caracteres.')
    .required('Campo obligatorio.')
})

export enum EnumPickingStep {
  ComponentLoaded = 0,
  FetchUser,
  BeginProcess,
  FetchRoute,
  ViewPickingStart,
  GenerateRoute,
  FetchProduct,
  ViewPickingProduct,
  ViewPickingProductDiff,
  UpdateProduct,
  UpdateProductOutOfStock,
  UpdateProductSkip,
  ViewNoRoute,
  ViewNoProduct,
  FetchPickingDetail,
  ViewPickingFinished,
  EmptyRoute,
  ViewPickingMessage,
  ViewPickingRouteDetails,
  ViewPickingRouteDetailsProgress,
  ModifyLPN,
  AssignTote
}
